import React, { useState, useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Button } from "@material-ui/core";
import styles from "./styles";
import GraphLineDot from "./GraphLineDot";
import QuizQuestion from "./QuizQuestion";

const Graph = (props) => {
  const {
    classes,
    setAnswers,
    setPhase2Answers,
    setPhase3Answers,
    questionAnswer,
    nextQuestion,
    answers,
    phase2Answers,
    phase3Answers,
    resetGraph,
    modalOpen,
    setShowTutorial,
    showTutorial,
    questionIndex,
  } = props;

  const [answeredCorrectly, setAnsweredCorrectly] = useState(null);
  const [answeredPartialy, setAnsweredPartialy] = useState(null);
  const [moved, setMoved] = useState(null);
  const [submitted, setSubmitted] = useState(false);

  // const [showTutorial, setShowTutorial] = useState(false);
  const [hideQuestionBeforeAnimation, setHideQuestionBeforeAnimation] =
    useState(true);

  useEffect(() => {
    setTimeout(() => {
      setHideQuestionBeforeAnimation(false);
    }, 500);
  }, []);

  useEffect(() => {}, [moved]);

  const handleSubmit = () => {
    setSubmitted(true);
    // questionAnswer.answer.includes('goes') && setTimeout(() => setDottedLineLabels(true), 1000)
  };

  console.log("hello questionIndex: ", questionIndex);

  return (
    <Grid container alignItems="center" direction="column">
      <Grid
        container
        item
        justify="center"
        alignItems="center"
        style={{ flexDirection: "column" }}
      >
        <Grid
          style={{
            position: "relative",
            display: "flex",
            alignSelf: "center",
          }}
        >
          <GraphLineDot
            questionAnswer={questionAnswer}
            setAnsweredCorrectly={setAnsweredCorrectly}
            setAnsweredPartialy={setAnsweredPartialy}
            setAnswers={setAnswers}
            setPhase2Answers={setPhase2Answers}
            setPhase3Answers={setPhase3Answers}
            answers={answers}
            phase2Answers={phase2Answers}
            phase3Answers={phase3Answers}
            answeredCorrectly={answeredCorrectly}
            submitted={submitted}
          />
          <Grid className={classes.questionDiv}>
            <QuizQuestion
              answeredPartialy={answeredPartialy}
              answeredCorrectly={answeredCorrectly}
              questionAnswer={questionAnswer}
              submitted={submitted}
              questionIndex={questionIndex}
            />
          </Grid>
        </Grid>
        <Button
          onClick={submitted ? nextQuestion : handleSubmit}
          className={submitted ? classes.nextButton : classes.submitButton}
        >
          {submitted ? "NEXT" : "SUBMIT"}
        </Button>
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(Graph);
